/* eslint-disable indent,no-new,no-undef */
import './bootstrap.js'
import Vue from 'vue'
import App from './App'
import './assets/scss/index.scss'
import 'trix/dist/trix.css'
import router from './router'
import { createPinia } from 'pinia'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['trix-editor']
// Vue.config.devtools = true
const pinia = createPinia()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  pinia
})



// WEBPACK FOOTER //
// ./src/main.js